import { render, staticRenderFns } from "./CommentActions.vue?vue&type=template&id=23b7d8ea&"
import script from "./CommentActions.vue?vue&type=script&lang=js&"
export * from "./CommentActions.vue?vue&type=script&lang=js&"
import style0 from "./CommentActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports